import React, { useState } from "react";
import { usePlayRecordingAction } from "../../hooks/useCallAction";
import PlayRecordingUI from "./PlayRecordingUI";
import { useRouteConfigModals } from "../contexts/RouteConfigModalsContext";

/**
 * PlayRecording component - can be used for root or off-hours contexts
 * @param {string} context - 'root' | 'offHours' (defaults to 'root')
 */
const PlayRecording = ({ 
  setOpenConfigureSlotModal, 
  route, 
  setRoute,
  context = 'root',
  hasValidationError = false,
}) => {
  const routeModals = useRouteConfigModals();
  const [localRecordings] = useState(
    () => JSON.parse(localStorage.getItem("organization"))?.recordings?.L || []
  );
  const recordings = routeModals?.recordings ?? localRecordings;
  const playRecordingLogic = usePlayRecordingAction(context, route, setRoute);
  const addRecordingOption = routeModals
    ? { label: "Add Recording", onClick: () => routeModals.openAddRecordingModal(playRecordingLogic.handleRecordingChange) }
    : undefined;

  return (
    <PlayRecordingUI
      {...playRecordingLogic}
      setOpenConfigureSlotModal={setOpenConfigureSlotModal}
      recordings={recordings}
      hasValidationError={hasValidationError}
      addRecordingOption={addRecordingOption}
    />
  );
};

export default PlayRecording;
